import { useEffect, useRef } from 'react';

interface UseSpecialRateCountdownParams {
  isSpecialRate: boolean;
  special_start_at?: number | null;
  special_end_at?: number | null;
  /**
   * 倒计时开始时调用，参数为剩余秒数和结束回调。
   * 调用方需将 onEnd 传给自己的倒计时实现（如 startTranslateCountdown(remaining, onEnd)）
   */
  onStartCountdown: (remaining: number, onEnd: () => void) => void;
  /** 倒计时到期后调用 */
  onEndCountdown: () => void;
}

/**
 * 特殊转化率倒计时调度 Hook
 *
 * 只负责"何时开始"的调度逻辑，不管理显示状态：
 * - special_start_at 已到 → 立即通知调用方开始倒计时
 * - special_start_at 未到 → 等到时间点后自动触发
 * - isSpecialRate/时间戳变化时重新调度，不依赖 visible
 */
export function useSpecialRateCountdown({
  isSpecialRate,
  // special_start_at,
  special_end_at,
  onStartCountdown,
  onEndCountdown,
}: UseSpecialRateCountdownParams) {
  const startWaiterRef = useRef<NodeJS.Timeout | null>(null);
  // 用 ref 保持回调最新引用，避免 useEffect 依赖频繁变更
  const onStartRef = useRef(onStartCountdown);
  const onEndRef = useRef(onEndCountdown);
  onStartRef.current = onStartCountdown;
  onEndRef.current = onEndCountdown;

  useEffect(() => {
    if (startWaiterRef.current) {
      clearTimeout(startWaiterRef.current);
      startWaiterRef.current = null;
    }

    if (!isSpecialRate) return;

    // const startAt = Number(special_start_at);
    const endAt = Number(special_end_at);

    const beginCountdown = () => {
      const remaining = endAt - Math.floor(Date.now() / 1000);
      console.log('====> remaining', remaining)
      if (remaining > 0) {
        onStartRef.current(remaining, () => onEndRef.current());
      }
    };

    beginCountdown();
    
    // const now = Math.floor(Date.now() / 1000);
    // if (now >= startAt) {
    //   beginCountdown();
    // } else {
    //   startWaiterRef.current = setTimeout(beginCountdown, (startAt - now) * 1000);
    // }

    return () => {
      if (startWaiterRef.current) {
        clearTimeout(startWaiterRef.current);
        startWaiterRef.current = null;
      }
    };
  }, [isSpecialRate, /* special_start_at, */ special_end_at]);
}
